import React from 'react'
import InvestmentRequest from "../components/investmentRequest/InvestmentRequest"
export default function InvestmentRequestPage() {
  return (
    <div>
      <InvestmentRequest/>
    </div>
  )
}
